import { gql } from "@apollo/client";

export const GetSpace = gql`
  query GET_SPACE {
    spaces {
      eSpaceId
      name
    }
  }
`;

export const GetPayRecords = gql`
  query GET_PAY_RECORDS(
    $eBuildingCaseId: ID!
    $identityNumber: String
    $don: String
    $household: String
  ) {
    payRecords(
      eBuildingCaseId: $eBuildingCaseId
      identityNumber: $identityNumber
      don: $don
      household: $household
    ) {
      contractNo
      contractType
      shouldPayDate
      shouldPayAmount
      realPayDate
      realPayAmount
      term
      donHouseholdDesc
    }
  }
`;
